'use strict';

export const sliderElements = id => ({
    closeButton: document.querySelector('div.close a'),
    lightboxContainer: document.querySelector('div#lightbox-container'),
    imageThumbs: document.querySelectorAll('div.image-thumbs .col .frame'),
    slider: (id => { return document.querySelector(`${id}.slider`) })(id),
    sliderImages: (id => { return document.querySelectorAll(`${id}.slider .slide`) })(id),
    toLeft: (id => { return document.querySelector(`${id}.slider .to.left`) })(id),
    toRight: (id => { return document.querySelector(`${id}.slider .to.right`) })(id),
    sliderNav: (id => { return document.querySelector(`${id}.slider .slider-nav`) })(id),
    sliderNavBlocks: (id => { return [...document.querySelectorAll(`${id}.slider ul.slider-nav li`)] })(id)
});
